module.exports = __webpack_public_path__ + "img/logo.4f912f8f.png";